import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNative } from "@/lib/nativeInit";
import { installGlobalErrorReporter } from "@/lib/errorReporter";

// Configure Capacitor status bar + native-only CSS hooks before render.
// No-op on web.
initNative();
// Wire window.onerror + unhandledrejection so runtime + async crashes
// stream to the backend (v139.2). ErrorBoundary handles render-time errors
// separately.
installGlobalErrorReporter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
